import { Common } from '@thecvlb/design-system/lib/src';
import classNames from 'classnames';

import { WITHINGS_BODY_PRO_2_SCALE_PRICE } from 'constants/defaults';

import ScaleSvg from 'assets/images/wm/scale.svg?react';

interface WMScalesCheckboxProps {
  isSelected: boolean;
  onToggle: () => void;
  priceWithDiscount?: string | null;
}

const WMScalesCheckbox: React.FC<WMScalesCheckboxProps> = ({
  isSelected,
  onToggle,
  priceWithDiscount
}) => {
  const parsePriceWithDiscount = priceWithDiscount === '0' ? 'Free' : `$${priceWithDiscount}`;

  return (
    <button
      className={classNames('flex w-full items-center justify-between gap-3 rounded-2xl py-1', {
        '-my-0.5 border-2 border-blue bg-blue-100 px-3.5': isSelected,
        'bg-white border border-px border-gray-200 px-4': !isSelected
      })}
      onClick={onToggle}
    >
      <div className="grow text-start text-mSm md:text-base">
        <h3 className="font-bold text-primary-800 md:text-base">Withings Body Pro 2 Scale</h3>
        <span>
          {!!priceWithDiscount && (
            <span className="mr-1 font-semibold text-primary-800">{parsePriceWithDiscount}</span>
          )}
          <span className="font-semibold text-gray line-through">
            ${WITHINGS_BODY_PRO_2_SCALE_PRICE}
          </span>
        </span>
      </div>
      <ScaleSvg className="size-14" />
      <Common.Checkbox checked={isSelected} color="blue" onChange={() => {}} />
    </button>
  );
};

export default WMScalesCheckbox;
